// @flow

import type {FulfillmentType} from 'data/bookings/types';

export const FULFILLMENT_TYPE: {[string]: FulfillmentType} = {
  DELIVERY: 'DELIVERY',
  IN_STORE: 'IN_STORE',
};
